import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex cursor-pointer items-center gap-1.5" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_3 = { class: "text-muted-foreground text-xs" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-2" }
const _hoisted_6 = { class: "flex flex-col gap-1" }
const _hoisted_7 = { class: "text-xs leading-none" }
const _hoisted_8 = ["href"]

import EmployeeAvatar from '@/components/EmployeeAvatar.vue';
    import type { User } from '@/types';
    import {
        Dialog,
        DialogBody,
        DialogClose,
        DialogContent,
        DialogDescription,
        DialogFooter,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import SearchInput from '@/components/SearchInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeAvatarRowDialog',
  props: {
    employees: {},
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const searchQuery = ref('');

    const filteredEmployees = computed(() => {
        if (!props.employees) return [];
        if (!searchQuery.value) return props.employees;

        const query = searchQuery.value.toLowerCase();
        return props.employees.filter(
            (employee) =>
                employee.name.toLowerCase().includes(query) ||
                employee.email.toLowerCase().includes(query),
        );
    });

    const visibleEmployees = computed(() => {
        return props.employees?.slice(0, 3);
    });

    const remainingCount = computed(() => {
        return Math.max(0, (props.employees?.length ?? 0) - 3);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleEmployees.value, (employee, index) => {
              return (_openBlock(), _createBlock(EmployeeAvatar, {
                key: index,
                user: employee,
                class: "-ml-3 first:ml-0"
              }, null, 8, ["user"]))
            }), 128)),
            (remainingCount.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " +" + _toDisplayString(remainingCount.value), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('companies.employees_assigned')) + " " + _toDisplayString(_ctx.company), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "flex flex-col gap-5" }, {
            default: _withCtx(() => [
              _createVNode(SearchInput, {
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                placeholder: _unref(t)('forms.search')
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("span", _hoisted_3, [
                (searchQuery.value !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(filteredEmployees.value?.length) + " " + _toDisplayString(_unref(t)('datatables.of')), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.employees?.length) + " " + _toDisplayString(_unref(t)('employee.employees')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployees.value, (employee) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: employee.id,
                    class: "flex items-center gap-4"
                  }, [
                    _createVNode(EmployeeAvatar, {
                      user: employee,
                      class: "size-8"
                    }, null, 8, ["user"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(employee.name), 1),
                      _createElementVNode("a", {
                        href: `mailto:${employee.email}`,
                        class: "text-secondary text-xs leading-none hover:underline"
                      }, _toDisplayString(employee.email), 9, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})